import React from 'react'
import HelperTooltip from '../helper_tooltip'

class TimeOffWorksheet extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      timeOffLeaveBalances: props.data.map(lpb => {
        return {
          title: lpb.title,
          leave_plan_benefit_id: lpb.id,
          time_off_leave_type_id: lpb.time_off_leave_type_id,
          estimated_balance: lpb.estimated_balance,
          preservable_balance: lpb.preservable_balance,
          time_off_type_description: lpb.time_off_type_description,
          benefit_summary: lpb.benefit_summary
        }
      })
    }
  }

  handleInput(leaveBalance, key, value) {
    const { timeOffLeaveBalances } = this.state
    this.setState({
      timeOffLeaveBalances: timeOffLeaveBalances.map(balance => {
        if (balance.leave_plan_benefit_id === leaveBalance.leave_plan_benefit_id && balance.time_off_leave_type_id === leaveBalance.time_off_leave_type_id) {
          balance[key] = value
        }
        return balance
      })
    })
  }

  renderPreservableInput(leaveBalance) {
    if(this.props.accrued_time_preservable) {
      return (
        <div className="col-xs-3 estimated-balance-container">
            <input
              className="form-control"
              placeholder="Est. Amount"
              type="number"
              value={leaveBalance.preservable_balance}
              onChange={ (e) => this.handleInput(leaveBalance, 'preservable_balance', parseInt(e.target.value) || 0)}/>
            <div className="estimated-balance-error-msg" />
          </div>
      )
    }
  }

  renderWorksheetForm(leaveBalance, index) {
    const helperText = leaveBalance.time_off_type_description || leaveBalance.benefit_summary
    return (
      <div className="row employee-time-off-type-row" key={index}>
        <div className="col-xs-3 time-off-name">
          <div className="time-off-leave-type-name">
            <p>{leaveBalance.title}</p>
            <span className="tooltip-helper">
              <HelperTooltip
                helper_text={helperText}
              />
            </span>
          </div>
        </div>
        <div className="col-xs-3 estimated-balance-container">
          <input
            className="form-control"
            placeholder="Est. Amount"
            type="number"
            value={leaveBalance.estimated_balance}
            onChange={ (e) => this.handleInput(leaveBalance, 'estimated_balance', parseInt(e.target.value) || 0)}/>
          <div className="estimated-balance-error-msg" />
        </div>
        { this.renderPreservableInput(leaveBalance) }
      </div>
    )
  }

  handleSubmit(e) {
    e.preventDefault()
    $.ajax({
      url: '/employees/save_employee_time_off_balances',
      method: 'POST',
      data: {time_off_leave_balances: this.state.timeOffLeaveBalances},
      success: (response) => {
        toastr.success(response.message)
      },
      error: (err) => {
        toastr.error(err.responseJSON.message)
      }
    })
  }

  totalEstimatedBalance() {
    const { timeOffLeaveBalances } = this.state
    return timeOffLeaveBalances.reduce((accumulator, balance) => {
      accumulator += balance.estimated_balance
      return accumulator
    }, 0)
  }

  totalPreservingAmount() {
    const { timeOffLeaveBalances } = this.state
    return timeOffLeaveBalances.reduce((accumulator, balance) => {
      accumulator += balance.preservable_balance
      return accumulator
    }, 0)
  }

  render(){
    return(
      <div className="work-sheet-form-container">
        <div className="row header">
          <div className="col-xs-3" />
          <p className="col-xs-3">Estimated or Actual Balance in Hours</p>
          { this.props.accrued_time_preservable ? <p className="col-xs-3">Amount to Preserve</p> : ""}
        </div>
        { this.state.timeOffLeaveBalances.map((leaveBalance, index) => this.renderWorksheetForm(leaveBalance, index) ) }

        <div className="row total-time-off-type-details">
          <p className="col-xs-3 time-off-name">Totals:</p>
          <p className="col-xs-3 total-estimated-balance">{this.totalEstimatedBalance() || 0}</p>
          { this.props.accrued_time_preservable ? <p className="col-xs-3 total-preserving-amount">{this.totalPreservingAmount() || 0}</p> : ""}
        </div>
        <div className="row">
          <div className="col-xs-6" />
          <div className="col-xs-3 max-allowed-error" />
        </div>
        <div className="row">
          <div className="col-xs-3 col-xs-offset-6">
            <input type="submit" value="Save" onClick={this.handleSubmit.bind(this)} className="pull-right btn btn-primary btn-darkgray btn-bdr-rds"/>
          </div>
        </div>
      </div>
    )
  }
}

export default TimeOffWorksheet
